import { useFavorites, type FavoriteType } from "@/hooks/useFavorites";

type FavoriteButtonProps = {
  type: FavoriteType;
  id: string;
  title: string;
  showLabel?: boolean;
  className?: string;
};

export default function FavoriteButton({ type, id, title, showLabel = true, className = "" }: FavoriteButtonProps) {
  const { toggleFavorite, isFavorite } = useFavorites();
  const active = isFavorite(type, id);

  return (
    <button
      type="button"
      onClick={() => toggleFavorite({ type, id, title })}
      aria-pressed={active}
      aria-label={active ? "取消收藏" : "收藏"}
      className={`inline-flex items-center justify-center gap-1.5 rounded-md border px-3 py-2 text-sm transition-colors cursor-pointer whitespace-nowrap ${
        active
          ? "border-primary-300 bg-primary-50 text-primary-700"
          : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
      } ${className}`}
    >
      <i className={`${active ? "ri-heart-fill" : "ri-heart-line"} text-base`}></i>
      {showLabel && <span>{active ? "已收藏" : "收藏"}</span>}
    </button>
  );
}